exports = module.exports = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-profile {\n  width: 300px;\n  height: 300px;\n  border-radius: 10px;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-attachment: inherit;\n  background-position: center;\n  display: inline-flex;\n}", ""]);

// exports
